import * as Sentry from '@sentry/browser';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { getCurrentProject } from 'src/app/store/project/project.selectors';
import { getCurrentConfig } from 'src/app/store/config/config.selectors';
import { getOrganizationId } from 'src/app/store/user/user.selectors';
import { combineLatest, Subject } from 'rxjs';
import { tap, takeUntil, map } from 'rxjs/operators';
import { Config } from 'src/app/store/config/models/config.model';

const { sentry } = environment;

@Injectable()
export class SentryDataCapture {
  private currentProject$ = this.store.select(getCurrentProject);
  private currentConfig$ = this.store.select(getCurrentConfig);
  private organizationId$ = this.store.select(getOrganizationId);

  private destroyed$ = new Subject();

  constructor(private store: Store<any>) {}

  start() {
    if (!sentry.enabled) {
      return;
    }

    const filteredProject$ = this.currentProject$.pipe(
      map((currentProject) => {
        if (!currentProject) {
          return currentProject;
        }
        // pull out ownerId
        const { ownerId, ...project } = currentProject;

        return project;
      }),
    );

    const filteredConfig$ = this.currentConfig$.pipe(
      map((currentConfig) => {
        if (!currentConfig) {
          return currentConfig;
        }
        // pulled out authRules
        const {
          values: { authRules, ...values },
          ...partConfig
        } = currentConfig;

        const config = {
          ...partConfig,
          values: {
            ...values,
          },
        } as Config;

        if (authRules) {
          const { type, entries } = authRules;

          config.values.authRules = { type, entries: entries.map(() => '*Censored*') };
        }

        return config;
      }),
    );

    combineLatest([this.organizationId$, filteredProject$, filteredConfig$])
      .pipe(
        tap(([organizationId, currentProject, currentConfig]) => {
          Sentry.setTag('organization.id', organizationId);
          Sentry.setExtras({
            currentProject,
            currentConfig,
          });
        }),
        takeUntil(this.destroyed$),
      )
      .subscribe();
  }

  stop() {
    this.destroyed$.next();
  }
}
